/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/root/loading/loading-wheel.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import9 from '@angular/core/src/change_detection/change_detection_util';
export class Wrapper_LoadingWheelComponent {
  /*private*/ _eventHandler:Function;
  context:import0.LoadingWheelComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.LoadingWheelComponent(p0,p1);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    this.context.ngOnDestroy();
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_LoadingWheelComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_LoadingWheelComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.LoadingWheelComponent>;
  _LoadingWheelComponent_0_3:Wrapper_LoadingWheelComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_LoadingWheelComponent_Host0,renderType_LoadingWheelComponent_Host,import5.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'loading-wheel',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_LoadingWheelComponent0(this.viewUtils,this,0,this._el_0);
    this._LoadingWheelComponent_0_3 = new Wrapper_LoadingWheelComponent(this.injectorGet(import8.LoadingWheelService,this.parentIndex),this.compView_0.ref);
    this.compView_0.create(this._LoadingWheelComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import7.ComponentRef_<any>(0,this,this._el_0,this._LoadingWheelComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.LoadingWheelComponent) && (0 === requestNodeIndex))) { return this._LoadingWheelComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._LoadingWheelComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._LoadingWheelComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const LoadingWheelComponentNgFactory:import7.ComponentFactory<import0.LoadingWheelComponent> = new import7.ComponentFactory<import0.LoadingWheelComponent>('loading-wheel',View_LoadingWheelComponent_Host0,import0.LoadingWheelComponent);
const styles_LoadingWheelComponent:any[] = ([] as any[]);
var renderType_LoadingWheelComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_LoadingWheelComponent,{});
export class View_LoadingWheelComponent0 extends import1.AppView<import0.LoadingWheelComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  /*private*/ _expr_20:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_LoadingWheelComponent0,renderType_LoadingWheelComponent,import5.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
    this._expr_20 = import9.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','loadingBackground','qadata','loading'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','loading eva-loader -lg'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,':svg:svg',new import3.InlineArray2(2,'viewBox','25 25 50 50'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,':svg:g',new import3.InlineArray2(2,'class','loader-rotation'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,':svg:circle',new import3.InlineArray16(10,'class','loader-line','cx','50','cy','50','fill','none','r','20'),(null as any));
    this._text_9 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_6,':svg:circle',new import3.InlineArray16(10,'class','loader-dot','cx','50','cy','50','fill','none','r','20'),(null as any));
    this._text_11 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_12 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_4,':svg:circle',new import3.InlineArray16(10,'class','loader-inset-line','cx','50','cy','50','fill','none','r','10'),(null as any));
    this._text_14 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','loader-text'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'Cargando',(null as any));
    this._text_18 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n',(null as any));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_20:boolean = !this.context.showLoadingWheel();
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementProperty(this._el_0,'hidden',currVal_20);
      this._expr_20 = currVal_20;
    }
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/root/loading/loading-wheel.component.ngfactory.ts